export const LABEL_COMPONENT = {
  ENTITY_QUALIFIED_ID: "entityQualifiedId", // basic info
  ENTITY_LABEL: "entityLabel",
  CHAIN_INFO_LABEL: "chainInfoLabel",
  QUALIFIED_ID: "qualifiedId",
  GENOME: "genome", // sequence genome
  SEQUENCE_NAME: "sequence Name",
  LOCATION: "location", // only relevant for genes
  COMPLEMENT: "complement", // only relevant for genes
};
